var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 15.6",
    style: {
      enableBackground: "new 0 0 50 15.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EF3F3F;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#EF3F3F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.6,13l1-2.2c1.1,0.8,2.6,1.3,4.2,1.3c1.7,0,2.4-0.6,2.4-1.4c0-2.4-7.3-0.7-7.3-5.4c0-2.1,1.7-3.9,5.3-3.9 c1.6,0,3.2,0.4,4.4,1.1l-0.9,2.2c-1.2-0.7-2.4-1-3.5-1c-1.7,0-2.4,0.6-2.4,1.4c0,2.3,7.3,0.7,7.3,5.3c0,2.1-1.7,3.9-5.3,3.9 C9.7,14.4,7.7,13.8,6.6,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.3,7.9c0-3.7,2.9-6.5,6.9-6.5c4,0,6.9,2.8,6.9,6.5s-2.9,6.5-6.9,6.5C21.2,14.4,18.3,11.7,18.3,7.9z  M29.1,7.9c0-2.4-1.7-4-3.9-4c-2.3,0-3.9,1.6-3.9,4c0,2.4,1.7,4,3.9,4C27.4,11.9,29.1,10.3,29.1,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.4,7.9c0-3.8,2.9-6.5,6.8-6.5c2.2,0,4,0.8,5.2,2.2l-1.9,1.7c-0.8-1-1.9-1.5-3.2-1.5c-2.4,0-4,1.7-4,4 c0,2.4,1.7,4,4,4c1.3,0,2.3-0.5,3.2-1.5l1.9,1.7c-1.2,1.5-3,2.3-5.2,2.3C36.4,14.4,33.4,11.7,33.4,7.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoc);
export default __webpack_public_path__ + "static/media/soc.52f2d4559b37ed77a906696575f8b294.svg";
export { ForwardRef as ReactComponent };